import { render, staticRenderFns } from "./FairnessDashboard.vue?vue&type=template&id=465251d8&scoped=true"
import script from "./FairnessDashboard.vue?vue&type=script&lang=js"
export * from "./FairnessDashboard.vue?vue&type=script&lang=js"
import style0 from "./FairnessDashboard.vue?vue&type=style&index=0&id=465251d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465251d8",
  null
  
)

export default component.exports